import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import theme from "./theme";
import store from "./store";
import { LoadScript } from "@react-google-maps/api";
// import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FormProvider } from "context/formContext";

const libraries = ["places"];
const routerBasename = process.env.PUBLIC_URL || "/";

// const tagManagerArgs = {
//   gtmId: "GTM-TJ4T378",
// };

// TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LoadScript
      libraries={libraries}
      googleMapsApiKey="AIzaSyDYfjHl41cQl4BQZZ35YKPh-sHhL0Vv2ZM"
      loadingElement={<div />}
    >
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Router basename={routerBasename}>
            <FormProvider>
              {/* <ToastContainer /> */}
              <App />
            </FormProvider>
          </Router>
        </Provider>
      </ThemeProvider>
    </LoadScript>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
